import React from "react";
import { AiOutlineMenu, AiOutlineClose } from "react-icons/ai";
import me from "../assets/sumits21.jpg";

import { useContext } from "react";
import { Context } from "../Context";

const Header = ({ menuOpen, setMenuOpen }) => {
  const { darkMode } = useContext(Context);

  return (
    <>
      <nav className={`${darkMode ? "lightMode" : "darkMode"}`}>
        <NavContent setMenuOpen={setMenuOpen} />
      </nav>
      <button className="navBtn" onClick={() => setMenuOpen(!menuOpen)}>
        {menuOpen ? <AiOutlineClose /> : <AiOutlineMenu />}
      </button>
    </>
  );
};

export const HeaderPhone = ({ menuOpen, setMenuOpen }) => {
  // console.log(darkMode);
  const { darkMode } = useContext(Context);
  return (
    <div
      className={`navPhone  ${darkMode ? "phoneLightMode" : "phoneDarkMode"} ${
        menuOpen ? "navPhoneComes" : ""
      }`}
    >
      <img src={me} alt="sk" />
      <NavContent setMenuOpen={setMenuOpen} />
    </div>
  );
};

const NavContent = ({ setMenuOpen }) => (
  <>
    {/* <img src={me} alt="Sumit" /> */}
    <h2>
      Sumit<span>KG.</span>
    </h2>
    <div>
      <a onClick={() => setMenuOpen(false)} href="#home">
        Home
      </a>
      <a onClick={() => setMenuOpen(false)} href="#work">
        Projects
      </a>
      <a onClick={() => setMenuOpen(false)} href="#timeline">
        Experience
      </a>
      <a onClick={() => setMenuOpen(false)} href="#services">
        Services
      </a>
      <a onClick={() => setMenuOpen(false)} href="#testimonials">
        Testimonials
      </a>
      <a onClick={() => setMenuOpen(false)} href="#contact">
        Contact
      </a>
    </div>
    <a href="mailto:sumitkumargautam35@gmail.com">
      <button>Email</button>
    </a>
  </>
);

export default Header;
